module.exports = "/static/assets/babb949cceaed30ec7f6c1c0b891e1fd.png";